import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect } from 'react';
import { queryClient } from '@/core/api/queryClient';
import { apiClient } from '@/core/api/client';
import { leerEmailPersistido, leerRefreshTokenPersistido, useSessionStore, } from '@/core/auth/sessionStore';
import { refrescarSesionCompartido } from '@/core/api/interceptors/refreshInterceptor';
import { ThemeProvider } from '@/core/theme';
import { ToastProvider } from '@/shared/components/Toast';
import { AppRouter } from '@/router/AppRouter';
import { drenarColaSiAplica, instalarHandlersGlobales, logger, } from '@/core/logging/logger';
import { authApi } from '@/data/api/authApi';
import { env } from '@/core/config/env';
/**
 * Rehidrata la sesión al arrancar la app. Si hay refresh + email
 * persistidos, hace un refresh proactivo para obtener un access token
 * y luego pide /auth/me. No podemos confiar sólo en el ciclo 401→retry
 * del interceptor porque Symfony devuelve 403 cuando no hay header de
 * auth en absoluto (no 401).
 */
async function bootstrapSesion() {
    const refresh = leerRefreshTokenPersistido();
    const email = leerEmailPersistido();
    if (!refresh || !email) {
        useSessionStore.getState().marcarHidratado();
        return;
    }
    useSessionStore.getState().setRefreshToken(refresh);
    try {
        await refrescarSesionCompartido(apiClient);
        const usuario = await authApi.me();
        useSessionStore.getState().setUsuario(usuario);
    }
    catch (err) {
        logger.warning('bootstrap.rehidratacion_fallida', { err: String(err) });
        useSessionStore.getState().limpiar();
    }
    finally {
        useSessionStore.getState().marcarHidratado();
    }
}
export function App() {
    useEffect(() => {
        instalarHandlersGlobales();
        void drenarColaSiAplica();
        void bootstrapSesion();
    }, []);
    return (_jsx(ThemeProvider, { children: _jsxs(QueryClientProvider, { client: queryClient, children: [_jsx(ToastProvider, { children: _jsx(AppRouter, {}) }), env.isDev ? _jsx(ReactQueryDevtools, { initialIsOpen: false }) : null] }) }));
}
